const STATUS_MAP: Record<string, { cls: string; label: string }> = {
  running:           { cls: 'badge-running', label: 'RUNNING' },
  active:            { cls: 'badge-running', label: 'ACTIVE' },
  processing:        { cls: 'badge-running', label: 'PROCESSING' },
  starting:          { cls: 'badge-warn',    label: 'STARTING' },
  stopping:          { cls: 'badge-warn',    label: 'STOPPING' },
  waiting_for_input: { cls: 'badge-warn',    label: 'WAITING' },
  switching:         { cls: 'badge-warn',    label: 'SWITCHING' },
  stopped:           { cls: 'badge-stopped', label: 'STOPPED' },
  terminated:        { cls: 'badge-error',   label: 'TERMINATED' },
  idle:              { cls: 'badge-stopped', label: 'IDLE' },
  error:             { cls: 'badge-error',   label: 'ERROR' },
};

export function StatusBadge({ status }: { status: string }) {
  const { cls, label } = STATUS_MAP[status] ?? { cls: 'badge-stopped', label: status.toUpperCase() };
  return (
    <span className={`badge ${cls}`}>
      <span className="badge-dot" />
      {label}
    </span>
  );
}
